'use client';

import { useEffect, useState } from 'react';
import invariant from 'tiny-invariant';

import { getNextApiRoute } from '../../utils/api';
import { typedFetch } from '../../utils/typedFetch';

type OneTrustTokenResponse = {
    success: boolean;
    message: string;
    token?: string;
};

/**
 * Hook to initialize OneTrust parameters.
 * Here we generate JWT and form a string to be inserted into the script.
 * All code is executed on the client, after rendering.
 */
export const useOneTrustParams = ({ customerKey }: { customerKey: string | undefined }) => {
    const [token, setToken] = useState<string>('');

    useEffect(() => {
        if (!customerKey) return;

        typedFetch<OneTrustTokenResponse>(getNextApiRoute(`onetrust/generate-token/${customerKey}`))
            .then(response => {
                invariant(response?.token, `RequestNewToken failed: ${response?.message}`);
                setToken(response.token);
            })
            .catch(error => {
                console.error('OneTrust token fetch failed:', error);
            });
    }, [customerKey]);

    return { token };
};
